<template>
	<div style="overflow-x:auto" v-if="data">
		<table class="table text-center">
			<thead style="color:white">
				<th class="bg-red">GUDANG</th>
				<th v-for="x in monthLength" :key="x"  class="bg-blue" >{{x}}</th>
				<th class="bg-green">Total</th>
			</thead>
			<tbody style="color:black">
				<tr v-for="datum in data" :key="datum.loc_code">
					<td class="bg-lg-red">{{datum.loc_code}}</td>
					<td v-for="x in monthLength" :key="x" :class="{'bg-lg-blue' : x == today.date() && parseInt(today.month()) + 1 == parseInt(filter.month.value) && today.year() == filter.year}">{{datum[`day_${x}`]}}</td>
					<td class="bg-lg-green">{{datum.total}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import moment from 'moment'
import qs from 'qs'

export default {
	data () {
		let today = new moment()
		return {
			monthLength : null,
      today,
      data : null,
      filter : null,
		}
  },
	props: ['filterUrl'],
  mounted () {

  },
  watch : {
    filterUrl(){
      this.fetchData();
    }
  },
  methods : {
    fetchData(){
      this.$http.get('/api/h1/vehicle-deviation?' + this.filterUrl)
      .then((resp)=>{
        let obj = qs.parse(this.filterUrl)
        this.filter = obj;
        this.monthLength = new Date(obj.year, obj.month , 0).getDate()

        this.data = resp.data.data;
      })
      .catch((err)=>{
        console.log(err);
      })
    }
  }
}
</script>

<style scoped>
	.bg-lg-green {
		background-color: 	#98FB98 !important;
	}

	.bg-green {
		background-color: 	#006400 !important;
	}

	.bg-lg-blue {
		background-color: #89CFF0 !important;
	}

	.bg-blue {
		background-color: #000033 !important;
	}

	.bg-red {
		background-color: #DC143C !important;
	}

	.bg-lg-red {
		background-color: #FA8072 !important;
	}
</style>